import { type Client } from '@optimizely/optimizely-sdk'
import {
  defaultOptimizelyContext,
  OptimizelyContextType,
  OptimizelyFeatureFlags,
} from 'models/Optimizely'
import { initializeOptimizelyClient } from './initializeOptimizelyClient'

export const getOptimizelyContextObject = async (
  userId: Parameters<Client['createUserContext']>[0],
  userAttributes?: Parameters<Client['createUserContext']>[1],
): Promise<OptimizelyContextType> => {
  const optimizelyClient = await initializeOptimizelyClient()

  const userContext = optimizelyClient?.createUserContext(userId, userAttributes)
  const featureFlags = defaultOptimizelyContext.featureFlags // all false by default

  if (optimizelyClient && userContext) {
    // Get decisions for all flags known to EG3 App
    const decisions = userContext.decideForKeys(
      Object.values(OptimizelyFeatureFlags).map((flag) => flag),
    )

    // userContext objects are not serializable, so we need to omit them from the OptimizelyDecision
    for (const [flag, decision] of Object.entries(decisions)) {
      const { userContext, ...decisionWithoutUserContext } = decision

      featureFlags[flag as OptimizelyFeatureFlags] = decisionWithoutUserContext
    }
  }

  return { featureFlags }
}
